// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cdv-200 {
  background-color: #2E7D32;
  color: white;
}

.cdv-201 {
  background-color: #0EA501;
  color: white;
}

.cdv-202 {
  background-color: #7CB342;
  color: white;
}

.cdv-203 {
  background-color: #1976D2;
  color: white;
}

.cdv-204 {
  background-color: #FFA500;
  color: white;
}

.cdv-205 {
  background-color: #1B5E20;
  color: white;
}

.cdv-206 {
  background-color: #FFB300;
  color: white;
}

.cdv-207 {
  background-color: #C2185B;
  color: white;
}

.cdv-208 {
  background-color: #6A1B9A;
  color: white;
}

.cdv-209 {
  background-color: #004D40;
  color: white;
}

.cdv-210 {
  background-color: #D32F2F;
  color: white;
}

.cdv-211 {
  background-color: #3949AB;
  color: white;
}

.cdv-212 {
  background-color: #00897B;
  color: white;
}

.cdv-213 {
  background-color: #263238;
  color: white;
}

#document-icons img {
  min-width: 50px;
  width: 5vw;
  cursor: pointer;
  z-index: 1;
  transition: transform 200ms ease-in, z-index 200ms;
}
#document-icons img:hover {
  z-index: 10;
  transform: scale(1.2);
}`, "",{"version":3,"sources":["webpack://./src/scss/_variables.scss","webpack://./src/app/components/help/help.component.scss"],"names":[],"mappings":"AA0BA;EAAW,yBAAA;EAA2B,YAAA;ACvBtC;;ADwBA;EAAW,yBAAA;EAA2B,YAAA;ACnBtC;;ADoBA;EAAW,yBAAA;EAA2B,YAAA;ACftC;;ADgBA;EAAW,yBAAA;EAA2B,YAAA;ACXtC;;ADYA;EAAW,yBAAA;EAA2B,YAAA;ACPtC;;ADQA;EAAW,yBAAA;EAA2B,YAAA;ACHtC;;ADIA;EAAW,yBAAA;EAA2B,YAAA;ACCtC;;ADAA;EAAW,yBAAA;EAA2B,YAAA;ACKtC;;ADJA;EAAW,yBAAA;EAA2B,YAAA;ACStC;;ADRA;EAAW,yBAAA;EAA2B,YAAA;ACatC;;ADZA;EAAW,yBAAA;EAA2B,YAAA;ACiBtC;;ADhBA;EAAW,yBAAA;EAA2B,YAAA;ACqBtC;;ADpBA;EAAW,yBAAA;EAA2B,YAAA;ACyBtC;;ADxBA;EAAW,yBAAA;EAA2B,YAAA;AC6BtC;;AAlEE;EACE,eAAA;EACA,UAAA;EACA,eAAA;EACA,UAAA;EACA,kDAAA;AAqEJ;AAlEE;EACE,WAAA;EACA,qBAAA;AAoEJ","sourcesContent":["// Variabile che è possibile richiamare dagli altri file scss\r\n$mat-primary-color: #35364A;\r\n\r\n$mat-secondary-color: #35364A;\r\n\r\n$navbar-text-selected: #00857E;\r\n\r\n$navbar-gray-text: #555667;\r\n\r\n$navbar-white-text: #FFFF;\r\n\r\n$error-color: #B50600;\r\n$warning-color: #C65015;\r\n$success-color: #056E4B;\r\n\r\n\r\n// Larghezza della sidebar\r\n$navbar-brand-width: 300px !default;\r\n$sidebar-width: 300px !default;\r\n\r\n// Logica usata\r\n//  Verde → esito positivo\r\n//  Blu → stato informativo / di sistema\r\n//  Arancio / Giallo → attenzione / transizione\r\n//  Rosso / Nero → rifiuti\r\n\r\n.cdv-200 { background-color: #2E7D32; color: white; } \r\n.cdv-201 { background-color: #0EA501; color: white; } \r\n.cdv-202 { background-color: #7CB342; color: white; } \r\n.cdv-203 { background-color: #1976D2; color: white; } \r\n.cdv-204 { background-color: #FFA500; color: white; } \r\n.cdv-205 { background-color: #1B5E20; color: white; } \r\n.cdv-206 { background-color: #FFB300; color: white; } \r\n.cdv-207 { background-color: #C2185B; color: white; } \r\n.cdv-208 { background-color: #6A1B9A; color: white; } \r\n.cdv-209 { background-color: #004D40; color: white; } \r\n.cdv-210 { background-color: #D32F2F; color: white; } \r\n.cdv-211 { background-color: #3949AB; color: white; } \r\n.cdv-212 { background-color: #00897B; color: white; } \r\n.cdv-213 { background-color: #263238; color: white; } ","@import \"../../../scss/_variables.scss\";\r\n#document-icons {\r\n  img {\r\n    min-width: 50px;\r\n    width: 5vw;\r\n    cursor: pointer;\r\n    z-index: 1;\r\n    transition: transform 200ms ease-in, z-index 200ms;\r\n  }\r\n\r\n  img:hover {\r\n    z-index: 10;\r\n    transform: scale(1.2);\r\n  }\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
